import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      {/* Header */}
      <div
        className="text-white"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h1 className="display-4 fw-bold mb-3">
                <i className="bi bi-file-earmark-text me-3"></i>
                Terms and Conditions
              </h1>
              <p className="lead mb-0">
                Please read these terms carefully before using SportsBid Arena
              </p>
            </div>
            <div className="col-md-4 text-md-end mt-3 mt-md-0">
              <Link to="/" className="btn btn-light btn-lg">
                <i className="bi bi-arrow-left me-2"></i>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0" style={{ borderRadius: "20px" }}>
              <div className="card-body p-5">
                <p className="text-muted mb-4">
                  <strong>Last Updated:</strong> January 13, 2026
                </p>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-1-circle-fill text-primary me-2"></i>
                    Acceptance of Terms
                  </h2>
                  <p>
                    By accessing and using SportsBid Arena ("the Service"), you accept and agree to be bound by 
                    these Terms and Conditions. If you do not agree to these terms, please do not use our Service.
                  </p>
                  <p>
                    These terms apply to all visitors, users, and others who access or use the Service, 
                    including organizers, bidders, and guests.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-2-circle-fill text-primary me-2"></i>
                    Description of Service
                  </h2>
                  <p>
                    SportsBid Arena is a free online platform that enables users to conduct player auctions 
                    for sports tournaments including cricket, football, basketball, and other sports. 
                    The Service includes:
                  </p>
                  <ul>
                    <li>Creating and managing auction events</li>
                    <li>Adding teams and players to auctions</li>
                    <li>Real-time bidding functionality</li>
                    <li>Team and player management tools</li>
                    <li>Auction analytics and reporting</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-3-circle-fill text-primary me-2"></i>
                    User Accounts
                  </h2>
                  <p>
                    To use certain features of the Service, you must register for an account. When you register:
                  </p>
                  <ul>
                    <li>You must provide accurate, current, and complete information</li>
                    <li>You are responsible for maintaining the confidentiality of your account credentials</li>
                    <li>You are responsible for all activities that occur under your account</li>
                    <li>You must notify us immediately of any unauthorized use of your account</li>
                  </ul>
                  <p>
                    We reserve the right to suspend or terminate accounts that violate these terms or 
                    engage in fraudulent or harmful activities.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-4-circle-fill text-primary me-2"></i>
                    User Conduct
                  </h2>
                  <p>You agree not to:</p>
                  <ul>
                    <li>Use the Service for any illegal or unauthorized purpose</li>
                    <li>Violate any laws in your jurisdiction</li>
                    <li>Upload or transmit viruses or malicious code</li>
                    <li>Interfere with or disrupt the Service or servers</li>
                    <li>Attempt to gain unauthorized access to any part of the Service</li>
                    <li>Harass, abuse, or harm other users</li>
                    <li>Use the Service for gambling or betting with real money</li>
                    <li>Impersonate any person or entity</li>
                    <li>Collect user information without consent</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-5-circle-fill text-primary me-2"></i>
                    Intellectual Property
                  </h2>
                  <p>
                    The Service and its original content, features, and functionality are owned by 
                    SportsBid Arena and are protected by international copyright, trademark, patent, 
                    trade secret, and other intellectual property laws.
                  </p>
                  <p>
                    You retain ownership of any content you upload to the Service (such as player images 
                    and team logos), but you grant us a license to use, display, and distribute such 
                    content in connection with the Service.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-6-circle-fill text-primary me-2"></i>
                    Free Service and Donations
                  </h2>
                  <p>
                    SportsBid Arena is provided free of charge. We may display advertisements to support 
                    the Service. We may also accept voluntary donations from users who wish to support 
                    the platform's development and maintenance.
                  </p>
                  <p>
                    We reserve the right to introduce premium features in the future, but core 
                    functionality will remain free.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-7-circle-fill text-primary me-2"></i>
                    Disclaimer of Warranties
                  </h2>
                  <p>
                    The Service is provided "as is" and "as available" without warranties of any kind, 
                    either express or implied. We do not guarantee that:
                  </p>
                  <ul>
                    <li>The Service will be uninterrupted or error-free</li>
                    <li>Defects will be corrected</li>
                    <li>The Service is free of viruses or harmful components</li>
                    <li>The results of using the Service will meet your requirements</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-8-circle-fill text-primary me-2"></i>
                    Limitation of Liability
                  </h2>
                  <p>
                    To the maximum extent permitted by law, SportsBid Arena shall not be liable for any 
                    indirect, incidental, special, consequential, or punitive damages, including but not 
                    limited to loss of profits, data, use, or goodwill, arising out of or in connection 
                    with your use of the Service.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-9-circle-fill text-primary me-2"></i>
                    Indemnification
                  </h2>
                  <p>
                    You agree to indemnify and hold harmless SportsBid Arena and its affiliates, officers, 
                    directors, employees, and agents from any claims, liabilities, damages, losses, and 
                    expenses arising out of your use of the Service or violation of these Terms.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-arrow-repeat text-primary me-2"></i>
                    Changes to Terms
                  </h2>
                  <p>
                    We reserve the right to modify these Terms at any time. We will notify users of 
                    significant changes by posting a notice on our website. Your continued use of the 
                    Service after such modifications constitutes acceptance of the updated Terms.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-x-circle text-primary me-2"></i>
                    Termination
                  </h2>
                  <p>
                    We may terminate or suspend your access to the Service immediately, without prior 
                    notice or liability, for any reason, including breach of these Terms. Upon termination, 
                    your right to use the Service will immediately cease.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-globe text-primary me-2"></i>
                    Governing Law
                  </h2>
                  <p>
                    These Terms shall be governed by and construed in accordance with the laws of Bangladesh, 
                    without regard to its conflict of law provisions. Any disputes arising under these Terms 
                    shall be subject to the exclusive jurisdiction of the courts of Bangladesh.
                  </p>
                </section>

                <section className="mb-4">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="bi bi-envelope text-primary me-2"></i>
                    Contact Us
                  </h2>
                  <p>
                    If you have any questions about these Terms, please contact us at:
                  </p>
                  <div className="bg-light p-4 rounded">
                    <p className="mb-2">
                      <i className="bi bi-envelope-fill text-primary me-2"></i>
                      <strong>Email:</strong>{" "}
                      <a href="mailto:rshuvo036@gmail.com">rshuvo036@gmail.com</a>
                    </p>
                    <p className="mb-0">
                      <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                      <strong>Address:</strong> Rajshahi, Bangladesh
                    </p>
                  </div>
                </section>

                <div className="text-center mt-5 pt-4 border-top">
                  <Link to="/" className="btn btn-primary btn-lg me-3">
                    <i className="bi bi-house me-2"></i>
                    Back to Home
                  </Link>
                  <Link to="/privacy-policy" className="btn btn-outline-primary btn-lg">
                    <i className="bi bi-shield-check me-2"></i>
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-4 bg-dark text-white text-center">
        <div className="container">
          <small className="text-white-50">
            © 2025 SportsBid Arena. All rights reserved.
          </small>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
